<template lang="pug">
    section#listagem
        ul.cursos
            router-link(:to="{ name: 'curso', params: { tipo: getTipoCurso(curso.tipo), slug: curso.slug } }", :class="isSaude ? 'saude' : getTipoCurso(curso.tipo)" v-for="curso, index in exibidos", :key="curso.slug", tag="li").curso
                .header
                    h2 {{ curso.nome_curso }}
                .preco
                    p.antigo(v-if="curso.preco_antigo") De
                        span   R$ {{curso.preco_antigo}}
                        |  Por
                    p.atual A partir de R$ {{curso.preco}}*

                .footer
                    p.duracao {{ curso.duracao}}
                    p.vercurso Ver o Curso
        button(@click="mostrarMais()", v-if="exibidos.length < cursos.length").carregar Carregar mais Cursos
</template>

<script>
export default {
    name: "section-listagem",
    props: {
        cursos: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            page: 1,
        }
    },
    computed: {
        isSaude() {
            return 'saude' === this.$route.params.tipo
        },
        exibidos() {
            return this.cursos.slice(0, this.page * 12)
        },
    },
    watch: {
        'cursos': function() {
            this.page = 1
        },
    },
    methods: {
        getTipoCurso(tipo) {
            if ('ENSMED' === tipo)
                return 'tecnico'
            if ('POS' === tipo)
                return 'pos-graduacao'
            return 'graduacao'
        },
        mostrarMais() {
            this.page += 1
        },
    },
}
</script>

<style lang="stylus" scoped src="./Listagem.styl"></style>
